// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { LinkModel, mapLink, MappedLink } from "@synd/Overrides/Widgets/Header/MainNavigation";

export const getMainNavigationWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/MainNavigation";
    })?.fields;
};

export const getHeaderShipToAddress = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/HeaderShipToAddress";
    });
};

export const getHeaderCurrencyMenu = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/CurrencyMenu";
    });
};

export const getHeaderLanguageMenu = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/LanguageMenu";
    });
};

export const getHeaderShipToAddressWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/HeaderShipToAddress";
    });
};

export const getSecondaryMainNavigationWidget = (state: ApplicationState) => {
    const links =
        getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
            return widget.type === "Header/MainNavigation" && widget.zone === "SecondaryMainNavigation";
        })?.fields?.links || [];
    const categoryIdsToLoad = {};
    const mappedLinks: MappedLink[] = links.reduce((acc: MappedLink[], link: LinkModel) => {
        const _link = mapLink(link, state, categoryIdsToLoad);
        if (_link) {
            acc.push(_link);
        }
        return acc;
    }, []);

    return { mappedLinks, categoryIdsToLoad };
};

export const getActionLinks = (state: ApplicationState) => {
    const actions = getWidgetsByPageId(state, getHeader(state).id).filter((widget: WidgetProps) => {
        return widget.zone === "ActionLinks";
    });
    return actions;
};
